import styled from 'styled-components';
import { size } from '../../layout/helpers';

export const Base = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const BaseHeader = styled.div`
  flex-shrink: 0;
  z-index: 80;
`;

export const BaseMain = styled.main<{ $impersonate?: boolean }>`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding-bottom: ${size(8)};
  background-color: ${(props) => props.theme.color.bg.main};
  min-height: ${(props) =>
    props.$impersonate ? `calc(100vh - ${props.theme.size.impersonateBarHeight})` : '100vh'};

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: ${size(4)} 0;
  }
`;

// Used to center the loader in BaseMain
export const BaseLoader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  width: 100%;
  position: fixed;
  z-index: 1100;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.theme.color.bg.main};
`;

export const BaseFooter = styled.div`
  flex-shrink: 0;
  margin-top: auto;
`;
